import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowUp, faClipboardList, faListCheck, faFolder, faCloudArrowUp, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FEATURES } from "./extractFeaturesList.js";
const assetMenu = [
  {
    label: "Uploaded Files",
    to: "uploaded-files",
    feature: FEATURES.ASSET_DASHBOARD,
    icon: <FontAwesomeIcon icon={faFileArrowUp} />,
    cName: "nav-text",
    default: true
  },
  {
    label: "Data Items",
    to: "data-items",
    feature: FEATURES.ASSET_DASHBOARD,
    icon: <FontAwesomeIcon icon={faListCheck} />,
    cName: "nav-text",
  },
  {
    label: "Audit Logs",
    to: "device-audit-logs",
    feature: FEATURES.ASSET_DASHBOARD,
    icon: <FontAwesomeIcon icon={faClipboardList} />,
    cName: "nav-text",
  },
  {
    label: "Remote Sessions",
    to: "device-details",
    feature: FEATURES.ASSET_DASHBOARD,
    icon: <FontAwesomeIcon icon={faInfoCircle} />,
    cName: "nav-text",
  },
  {
    label: "File From Machine",
    to: "file-from-machine",
    feature: FEATURES.ASSET_DASHBOARD,
    icon: <FontAwesomeIcon icon={faFolder} />,
    cName: "nav-text",
  },
  {
    label: "File To Machine",
    to: "file-to-machine",
    feature: FEATURES.ASSET_FILETOMACHINE,
    icon: <FontAwesomeIcon icon={faCloudArrowUp} />,
    cName: "nav-text",
  }

];

export default assetMenu;